import { render, staticRenderFns } from "./PosLoginForm.vue?vue&type=template&id=b2b8be88&scoped=true"
import script from "./PosLoginForm.vue?vue&type=script&lang=js"
export * from "./PosLoginForm.vue?vue&type=script&lang=js"
import style0 from "./PosLoginForm.vue?vue&type=style&index=0&id=b2b8be88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b8be88",
  null
  
)

export default component.exports